import React from 'react';
/**
 * ErrorBoundary will ensure that something is rendered in your react application
 * if any of the child components within it throws an unexpected error.
 * The `render` prop expects a function that returns a React Element to
 * display in the event of an error. It is passed the error.
 *
 * NOTE: This is only a 'class component' because there is currently no functional
 * equivalent for componentDidCatch.
 */
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.error(error, errorInfo);
        this.setState({ error });
    }
    render() {
        if (this.state.error) {
            return this.props.render(this.state.error);
        }
        return this.props.children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map